import React, { useContext, useState } from "react"
import { useNavigate } from "react-router-dom"
import UserContext from "../context/UserContext"
import { F_INDEX } from "../constants/routes"
import HeaderMobile from "./HeaderMobile"
import HeaderDesktop from "./HeaderDesktop"
import ContactFormDialog from "./ContactFormDialog"

const HeaderRoot = ({ content, showUserMenu, settings, bookmanagement, isMobile }) => {
  const [showHelp, setShowHelp] = useState(false)
  const navigate = useNavigate()

  const { setUserDataExternal } = useContext(UserContext)

  const handleLogout = () => {
    setUserDataExternal(null)
    localStorage.removeItem("user")
    localStorage.removeItem("settings")
    localStorage.removeItem("licence")
    navigate(F_INDEX)
  }

  return (
    <>
      {isMobile ? (
        <HeaderMobile handleLogout={handleLogout} handleSupport={() => setShowHelp(true)} />
      ) : (
        <HeaderDesktop
          handleLogout={handleLogout}
          content={content}
          showUserMenu={showUserMenu}
          settings={settings}
          bookmanagement={bookmanagement}
          handleSupport={() => setShowHelp(true)}
        />
      )}

      {showHelp && (
        <ContactFormDialog
          text="Hast Du eine Frage? Hier kannst Du Kontakt zum Schuladministrator und dem Bookay-Support aufnehmen."
          placeholder="Beschreibe dein Anliegen..."
          handleClose={() => setShowHelp(false)}
        />
      )}
    </>
  )
}

export default HeaderRoot
